import { TRIAL_DAYS } from "../../../constants/trial";
import L from "../../../constants/baysportLabels";
import { LANDING_SCREEN } from "./landingAssets";
import { MESSENGERS_MODULE_PRICE_RUB } from "../../../utils/messengersModuleAccess";

/** Контент главной — ритм и структура как у 1С:Фитнес, продукт Бай.Спорт. */

export const AIO_HERO = {
  brand: L.productName,
  h1Before: "Программа для управления",
  h1Highlight: "спортивным клубом",
  lead:
    "Сервис «всё в одном»: журнал, абонементы, CRM и приложение родителей. Сокращает хаос в секции и помогает зарабатывать.",
  primaryCta: `Попробовать ${TRIAL_DAYS} дней`,
  secondaryCta: "Кому подойдёт",
  secondaryTo: "/dlya-kogo",
  trialNote: `${TRIAL_DAYS} дней «Максимального» бесплатно · без карты · от 790 ₽/мес`,
  screen: {
    src: LANDING_SCREEN.ownerHome,
    alt: "Сводка клуба в Бай.Спорт",
  },
  screenSecondary: {
    src: LANDING_SCREEN.clientHome,
    alt: "Приложение клиента",
  },
};

export const AIO_PROGRAM = {
  title: `Что умеет ${L.productName}`,
  slides: [
    {
      id: "clients",
      icon: "users",
      title: "Система учёта",
      items: [
        "Клиентская база",
        "История занятий и оплат",
        "Продления абонементов",
        "Контроль должников",
      ],
    },
    {
      id: "schedule",
      icon: "calendar",
      title: "Расписание и журнал",
      items: [
        "Группы и пробные",
        "Онлайн-запись",
        "Отметка в один клик",
        "Списание с абонемента",
      ],
    },
    {
      id: "crm",
      icon: "funnel",
      title: "CRM-система",
      items: [
        "Заявки из всех каналов",
        "Воронка продаж",
        "Автоматические задачи",
        "Напоминания клиентам",
      ],
    },
    {
      id: "apps",
      icon: "phone",
      title: "Мобильные приложения",
      items: [
        "Приложение для родителей",
        "Кабинет владельца",
        "Кабинет тренера",
        "Бренд клуба на экране",
      ],
    },
  ],
};

export const AIO_WHY = {
  titleBefore: "Автоматизируем всё, что мешает",
  titleAccent: "вести секцию",
  points: [
    "Журнал, абонементы и оплаты в одном месте",
    "PWA для родителей под логотипом клуба",
    "Кабинеты владельца и тренера с телефона",
    "Заявки и напоминания без Excel",
  ],
  cta: "Попробовать бесплатно",
};

export const AIO_AUDIENCES = {
  id: "audience",
  titleBefore: `${L.productName} подойдёт`,
  titleAccent: "вашему клубу",
  lead: "От одной группы до сети площадок. Отдельные страницы под вид спорта.",
  items: [
    {
      id: "solo",
      icon: "whistle",
      tone: "violet",
      title: "Соло-тренер",
      text: "Группы, журнал и абонементы без администратора и Excel.",
      to: "/dlya-trenera",
    },
    {
      id: "fight",
      icon: "glove",
      tone: "orange",
      title: "Единоборства",
      text: "Карате, бокс, самбо — журнал на татами и кабинет родителей.",
      to: "/dlya-edinoborstv",
    },
    {
      id: "dance",
      icon: "ribbon",
      tone: "violet",
      title: "Танцы",
      text: "Направления, репетиции и абонементы под брендом студии.",
      to: "/dlya-tancev",
    },
    {
      id: "gym",
      icon: "barbell",
      tone: "orange",
      title: "Гимнастика",
      text: "Уровни групп, cheer и прозрачность для родителей.",
      to: "/dlya-gimnastiki",
    },
    {
      id: "swim",
      icon: "ball",
      tone: "violet",
      title: "Плавание",
      text: "Группы по уровням, отметки у бортика, абонементы бассейна.",
      to: "/dlya-plavaniya",
    },
    {
      id: "football",
      icon: "nodes",
      tone: "orange",
      title: "Футбол",
      text: "U-команды, журнал на поле и взносы без чата на 200 сообщений.",
      to: "/dlya-futbola",
    },
  ],
};

export const AIO_MARQUEE = {
  id: "niches",
  titleBefore: "Одна система —",
  titleAccent: "много видов спорта",
  lead: "Не «ещё одна CRM», а контур под реальные секции.",
  items: [
    "Футбол",
    "Единоборства",
    "Плавание",
    "Танцы",
    "Гимнастика",
    "Теннис",
    "Йога",
    "Кроссфит",
    "Хоккей",
    "Акробатика",
    "Бокс",
    "Чирлидинг",
  ],
};

export const AIO_COMPARE = {
  titleBefore: "Что обычно",
  titleAccent: "заменяют",
  lead: "Типичный хаос секции — и как это выглядит в Бай.Спорт.",
  rows: [
    {
      id: "excel",
      before: "Excel и таблицы",
      after: "Журнал, абонементы и оплаты в одном месте",
    },
    {
      id: "chats",
      before: "Переписки в мессенджерах",
      after: "PWA родителей, явка и лента клуба",
    },
    {
      id: "paper",
      before: "Бумажный журнал",
      after: "Отметка в один клик с телефона тренера",
    },
    {
      id: "apps",
      before: "Отдельное приложение «на заказ»",
      after: "Готовое PWA под вашим брендом",
    },
  ],
};

export const AIO_APP_BANNER = {
  id: "apps",
  titleAccent: "Мобильные приложения",
  titleRest: "для родителей, тренера и владельца",
  lead: "PWA на главный экран. Без публикации в App Store и Google Play.",
  cta: `Попробовать ${TRIAL_DAYS} дней`,
  src: LANDING_SCREEN.clientHome,
  alt: "Приложение клиента",
  callouts: [
    { id: "a", label: "Расписание и посещения", tone: "violet" },
    { id: "b", label: "Абонемент и оплаты", tone: "violet" },
    { id: "c", label: "Лента и чат группы", tone: "orange" },
  ],
};

export const AIO_TRUST = {
  titleBefore: "Старт",
  titleAccent: "без риска",
  items: [
    {
      id: "trial",
      title: `${TRIAL_DAYS} дней полного доступа`,
      text: "тариф «Максимальный», карта не нужна",
    },
    {
      id: "brand",
      title: "Под брендом клуба",
      text: "логотип и цвета на экране клиента",
    },
    {
      id: "data",
      title: "Данные клуба отдельно",
      text: "своя организация и свой тариф",
    },
    {
      id: "support",
      title: "Живая поддержка",
      text: "помогаем запуститься и ответить на вопросы",
    },
  ],
};

export const AIO_TASKS = {
  title: "Всё для клуба —",
  titleAccent: "уже внутри",
  items: [
    "Работа с клиентами",
    "Журнал и расписание",
    "Абонементы и оплаты",
    "Воронка заявок",
    "Лента и сообщество",
    "Мессенджеры Telegram и Max",
    "Аналитика клуба",
    "Кабинет тренера",
  ],
  src: LANDING_SCREEN.ownerHome,
};

export const AIO_STEPS = {
  title: "Шаги к подключению",
  items: [
    {
      num: "1",
      title: "Зарегистрируйте клуб",
      text: `5 минут. ${TRIAL_DAYS} дней «Максимального» — без карты.`,
    },
    {
      num: "2",
      title: "Настройте группы и абонементы",
      text: "Шаблоны под секции. Клиентов пригласите ссылкой или QR.",
    },
    {
      num: "3",
      title: "Начните отмечать занятия",
      text: "Родители уже видят явку. Оплаты и боты — когда будете готовы.",
    },
    {
      num: "4",
      title: "Отдайте приложение клиентам",
      text: "PWA под вашим брендом — без магазинов приложений.",
    },
  ],
};

export const AIO_FINAL_CTA = {
  title: `Попробуйте ${L.productName} ${TRIAL_DAYS} дней бесплатно`,
  lead: "Соберите журнал, абонементы и приложение клиентов в одной системе.",
  primary: "Начать бесплатно",
  secondary: "Смотреть тарифы",
};

export const AIO_FAQ = [
  {
    q: `Чем ${L.productName} отличается от обычной CRM?`,
    a: "Помимо учёта клиентов здесь сразу есть журнал, абонементы, оплаты и мобильное PWA под брендом клуба — для родителей, тренера и владельца.",
  },
  {
    q: "Что такое PWA и нужно ли публиковать приложение в магазинах?",
    a: "PWA — веб-приложение на главный экран телефона. App Store и Google Play не нужны: клиент открывает ссылку клуба и добавляет ярлык.",
  },
  {
    q: "Какие приложения получают родители, тренер и владелец?",
    a: "Родители — расписание, явку, абонемент и ленту. Тренер — журнал и группы. Владелец — сводку, клиентов, финансы и настройки. Всё в одной системе.",
  },
  {
    q: `Что входит в ${TRIAL_DAYS} дней бесплатно?`,
    a: `При регистрации клуб получает ${TRIAL_DAYS} дней тарифа «Максимальный» без привязки карты. Потом выбираете подходящий платный тариф.`,
  },
  {
    q: "Как считается стоимость?",
    a: "Тариф оплачивается за каждый клуб отдельно. Можно вести несколько организаций — платите только за те, что используете.",
  },
  {
    q: "Можно ли подключить Telegram или Max?",
    a: `Да. Боты клуба — отдельный модуль по подписке (от ${MESSENGERS_MODULE_PRICE_RUB} ₽/мес).`,
  },
  {
    q: "Подойдёт ли, если я работаю один?",
    a: "Да. Можно начать с одной группы на стартовом тарифе и позже перейти на расширенный — данные останутся.",
  },
];

export const AIO_PRICING = {
  title: "Тарифы под размер секции",
  lead: `Тариф — за каждый клуб отдельно. ${TRIAL_DAYS} дней «Максимального» бесплатно при регистрации, карта не нужна. Мессенджеры — опциональный модуль от ${MESSENGERS_MODULE_PRICE_RUB} ₽/мес.`,
};

export const AIO_PWA = AIO_APP_BANNER;
export const AIO_APP_PROMO = {
  title: AIO_APP_BANNER.titleAccent,
  titleAccent: AIO_APP_BANNER.titleRest,
  text: AIO_APP_BANNER.lead,
  cta: AIO_APP_BANNER.cta,
};
export const AIO_PILLARS = AIO_PROGRAM.slides.map((slide) => ({
  id: slide.id,
  title: slide.title,
  text: slide.items.join(" · "),
}));
export const AIO_NARRATIVE = AIO_WHY;
export const AIO_MODULES = { title: "", lead: "", items: [] };
export const AIO_STATS = [];
export const AIO_NICHES = AIO_MARQUEE;
export const AIO_RESULTS = { title: "", lead: "", items: [] };
export const AIO_DEEP = { title: "", items: [] };
export const AIO_SHOWCASE = { titleBefore: "", titleHighlight: "", lead: "", items: [] };
export const AIO_HIGHLIGHTS = [];
